import { render, staticRenderFns } from "./SelectItems.vue?vue&type=template&id=a19e6112&scoped=true&"
import script from "./SelectItems.vue?vue&type=script&lang=js&"
export * from "./SelectItems.vue?vue&type=script&lang=js&"
import style0 from "./SelectItems.vue?vue&type=style&index=0&id=a19e6112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19e6112",
  null
  
)

export default component.exports